(()=>{
  if(window.__sg)return;window.__sg=1;
  const d=document,root=d.documentElement;
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const editing=()=>!!(window.Shopify&&Shopify.designMode);
  let io,raf=0;

  const reveal=scope=>{
    const els=(scope||d).querySelectorAll('.sg-reveal:not(.is-in)');
    if(!els.length)return;
    if(reduce||editing()||!('IntersectionObserver' in window)){els.forEach(e=>e.classList.add('is-in'));return}
    io=io||new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}}),{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    els.forEach(e=>io.observe(e));
  };

  const onScroll=()=>{
    if(raf)return;
    raf=requestAnimationFrame(()=>{raf=0;const h=d.querySelector('.sg-header');if(h)h.classList.toggle('is-scrolled',scrollY>12)});
  };

  const setMenu=open=>{
    root.classList.toggle('sg-menu-open',open);
    d.querySelectorAll('[data-sg-menu]').forEach(b=>b.setAttribute('aria-expanded',String(open)));
  };

  const filter=btn=>{
    const wrap=btn.closest('section');if(!wrap)return;
    const val=btn.dataset.sgFilter;
    wrap.querySelectorAll('[data-sg-filter]').forEach(b=>b.classList.toggle('is-active',b===btn));
    wrap.querySelectorAll('[data-cat]').forEach(c=>{
      const show=val==='all'||c.dataset.cat===val;
      if(show&&c.hidden){
        c.hidden=false;c.classList.add('is-in');
        if(!reduce&&c.animate)c.animate([{opacity:0,transform:'translateY(14px)'},{opacity:1,transform:'none'}],{duration:600,easing:'cubic-bezier(.22,1,.36,1)'});
      }else if(!show){c.hidden=true}
    });
  };

  d.addEventListener('click',e=>{
    if(e.target.closest('[data-sg-menu]')){setMenu(!root.classList.contains('sg-menu-open'));return}
    if(root.classList.contains('sg-menu-open')&&e.target.closest('.sg-drawer a'))setMenu(false);
    const f=e.target.closest('[data-sg-filter]');
    if(f)filter(f);
  });
  d.addEventListener('keydown',e=>{if(e.key==='Escape')setMenu(false)});
  matchMedia('(min-width:990px)').addEventListener('change',e=>{if(e.matches)setMenu(false)});
  addEventListener('scroll',onScroll,{passive:true});
  addEventListener('pageshow',()=>setMenu(false));
  d.addEventListener('shopify:section:load',e=>{reveal(e.target);onScroll()});

  reveal();onScroll();
})();
